import React from 'react';
import { get, find, map } from 'lodash';
import { Row, FlexContainer, Column, Divider } from '../../common';

const MobileCard = (shopperInfo) => {
    const getFieldInfo = (name, field) => get(find(shopperInfo, ({ key }) => key === name), field || 'render');

    const RowInfo = (elements) => (
        <>
            <Divider />
            <Row>
                { map(elements, (element, key) => <Column key={key} borderLeft={key > 0 ? '1px solid #eaeaea' : null}>{ getFieldInfo(element) }</Column>) }
            </Row>
        </>
    );

    return (
        <FlexContainer
            direction='column'
            backgroundColor='#FFFFFF'
            padding={16}
            width='100%'
            boxShadow
            borderRadius={3}
        >
            <Row>
                <Column>
                    {getFieldInfo('name')}
                </Column>
                <Column maxWidth={100}>
                    {getFieldInfo('status')}
                </Column>
            </Row>
            { map([['foundrate', 'fillrate', 'contactability'], ['ordersCompleted', 'lastConnection']], (elements, key) => <RowInfo key={key} {...elements} />) }
            <Divider />
            <Row justify='center'>
                {getFieldInfo('salesChannelActive', 'value')}
            </Row>
        </FlexContainer>
    );
};

export default MobileCard;
